import { defineComponent } from 'vue';
import { MONET_URL } from '@/static/urls';
import IntroductionCode from '@/presentation/components/introduction/introduction.code';

export default defineComponent({
	setup: () => {
		const code = new IntroductionCode();

		return {
			monetUrl: MONET_URL,
			activeDashboardAvailable: code.activeDashboardAvailable,
			handleRequestDemoClick: code.handleRequestDemoClick.bind(code)
		};
	}
});
